import { useAction, useAtom } from '@reatom/npm-react'
import styled, { css } from 'styled-components'

import { Button } from '@blade/ui-kit'
import { useTranslation } from '@root/shared/localization'
import { FilterIcon } from '@root/shared/ui-kit'

import { exploreFilterDrawer } from '../../atoms/reatom-explore-filter-drawer'

import { ExploreFilterCount } from './explore-filter-count'

import type { ExploreFiltersAtom } from '../../atoms'

export type ExploreFilterButtonProps = {
  model: ExploreFiltersAtom
  size?: 'normal' | 'small'
}

export const ExploreFilterButton = ({
  model,
  size = 'normal',
}: ExploreFilterButtonProps) => {
  const { t } = useTranslation()
  const [appliedFiltersCount] = useAtom(model.appliedFiltersCount)
  const [exploreFilterDrawerState, setExploreFilterDrawerState] = useAtom(
    exploreFilterDrawer.exploreFilterDrawer,
  )
  const closeExploreFilter = useAction(exploreFilterDrawer.closeAction)
  return (
    <FilterButton
      iconLeft={
        <FilterIcon
          color={
            appliedFiltersCount ? 'var(--primary-9)' : 'var(--background-8)'
          }
        />
      }
      size={size === 'normal' ? 'h36' : 'h20'}
      variant="soft"
      radius="rounded"
      type="button"
      onClick={() => {
        if (exploreFilterDrawerState) {
          closeExploreFilter()
        } else {
          setExploreFilterDrawerState(() => model)
        }
      }}
    >
      <FilterButtonLabel $isActive={!!appliedFiltersCount}>
        {t('common.filter_other')}
      </FilterButtonLabel>
      {appliedFiltersCount ? (
        <ExploreFilterCount count={appliedFiltersCount} />
      ) : undefined}
    </FilterButton>
  )
}

const FilterButton = styled(Button)`
  background: var(--background-3);
  gap: 2px;

  ${({ size }) =>
    size === 'h20' &&
    css`
      font-size: 11px;
      font-weight: 600;
    `};
`

const FilterButtonLabel = styled.span<{ $isActive: boolean }>`
  color: ${(props) => (props.$isActive ? 'var(--text-12)' : 'inherit')};
`
